import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Signup from '../../components/signup/Signup';

function Signuppage() {
    return (
        <div>
        <Signup/>
        </div>
    )
}

export default Signuppage
